import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ListItemText, Menu } from '@mui/material';
import { SVGIcon, colors, PortalButton } from '@custom-components';
import {
  StyledMenuItem,
  IconWrapper,
  DropDownLabelWrapper,
  DropdownArrowIconWrapper,
  StyledTypography
} from './DropDownMenu.styles';

function DropDownMenu(props) {
  const { values, handleValueChange, disabled, label } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleItemClick = (value) => {
    handleValueChange(value);
    handleClose();
  };

  return (
    <>
      <PortalButton
        onClick={handleClick}
        btnTheme="outlined"
        disabled={disabled}
        fullWidth
        style={{
          backgroundColor: disabled ? colors.colorGrey05 : '#fff',
          border: disabled ? `1px solid ${colors.colorGrey03}` : `1px solid ${colors.colorBlue02}`,
          fontWeight: 600
        }}
      >
        <DropDownLabelWrapper color={disabled ? colors.colorGrey03 : colors.colorBlue02}>{label}</DropDownLabelWrapper>
        <DropdownArrowIconWrapper color={disabled ? colors.colorGrey03 : colors.colorBlue02}>
          <SVGIcon
            className="icon"
            selectedIcon="arrowFill"
            iconColor={disabled ? colors.colorGrey03 : colors.colorBlue02}
            position="static"
            rotate={open ? 180 : 0}
          />
        </DropdownArrowIconWrapper>
      </PortalButton>
      <Menu
        id="drop-down-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={2}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {values.map((item) => (
          <StyledMenuItem key={item.value} value={item.value} onClick={() => handleItemClick(item.value)}>
            {item.icon && (
              <IconWrapper>
                <SVGIcon
                  selectedIcon={item.icon}
                  iconColor={item.value === 'Delete' ? colors.colorRed : colors.colorGrey02}
                  width="20px"
                  height="20px"
                />
              </IconWrapper>
            )}
            <ListItemText
              primary={<StyledTypography isDelete={item.value === 'Delete'}>{item.label}</StyledTypography>}
            />
          </StyledMenuItem>
        ))}
      </Menu>
    </>
  );
}

DropDownMenu.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      icon: PropTypes.string
    })
  ),
  handleValueChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string
};

DropDownMenu.defaultProps = {
  values: [],
  disabled: false,
  handleValueChange: () => {},
  label: ''
};

export default DropDownMenu;
